import { sv, de, enUS, fi, da, nn } from 'date-fns/locale'
import { utcToZonedTime, format as dateFnsFormat } from 'date-fns-tz'
import { get } from 'lodash-es'
import { decodedToken } from './services/auth-service'
import { useToast } from 'vue-toastification'

function formatDate(isoDate: string, format = 'ppp') {
  const locales = {
    sv, de, en: enUS, fi, da, nn
  }
  const culture = get(decodedToken.value, 'iso_code', 'en-US').substr(0, 2)
  const locale = get(locales, culture, locales.en)
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const zonedDate = utcToZonedTime(isoDate, timeZone)

  return dateFnsFormat(zonedDate, format, { locale, timeZone })
}

function toast(message: string, type: 'success' | 'error' = 'success') {
  const toast = useToast()
  toast[type](message, { hideProgressBar: true })
}

export { formatDate, toast }
